import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcArrowdropFillNomargin(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "8",
    fill: "none",
    viewBox: "0 0 12 8",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.45 0c.46 0 .716.539.429.903L6.429 7.79a.546.546 0 0 1-.858 0L.121.903C-.166.539.09 0 .551 0z"
  }));
}
var IcArrowdropFillNomargin = createNolIcon(/*#__PURE__*/forwardRef(SvgIcArrowdropFillNomargin));

export { IcArrowdropFillNomargin as I };
